import { render, staticRenderFns } from "./ViewTaxStandard.vue?vue&type=template&id=127b19c6"
import script from "./ViewTaxStandard.vue?vue&type=script&lang=js"
export * from "./ViewTaxStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports